import { Button, CaptureClicksRichText } from '@/features/shared';
import { MuiTypography } from '@/features/shared/material-ui';
import clsx from 'clsx';
import React, { memo, PropsWithChildren } from 'react';
import { LandingPageContentProps } from './LandingPageContent.interface';
import useStyles from './LandingPageContent.styles';

const LandingPageContent = ({
  superheading,
  headline,
  subheading,
  primaryCTA,
  secondaryCTA,
  className: overrideClassName,
  theme,
  fullWidthContent,
  contentButtons,
  children,
  alignment,
}: PropsWithChildren<Br.PropsWithContentButtons<LandingPageContentProps>>) => {
  const classes = useStyles({});
  const rootClassName = clsx(
    classes.root,
    `${theme}-theme`,
    `align-${alignment}`,
    overrideClassName,
  );
  const wrapperWidthClass = fullWidthContent ? 'full-width-content' : '';
  const wrapperClassName = clsx(classes.wrapper, wrapperWidthClass);
  const hasPrimaryCTA = primaryCTA?.href || primaryCTA?.marketoLink;
  const hasSecondaryCTA = secondaryCTA?.href || secondaryCTA?.marketoLink;

  return (
    <div className={rootClassName}>
      <div className={wrapperClassName}>
        {contentButtons?.content}

        {superheading && (
          <MuiTypography
            data-testid="qa-cta-component-superHeading"
            variant="overline"
            component="h5"
            className={classes.superheading}
          >
            {superheading}
          </MuiTypography>
        )}
        {headline && (
          <CaptureClicksRichText
            customStyles
            theme={theme}
            content={headline}
            className={clsx(classes.headline, 'gtm-headline')}
            containerProps={{ className: classes.headlineContainer }}
          />
        )}
        {subheading && (
          <CaptureClicksRichText
            customStyles
            theme={theme}
            content={subheading}
            className={classes.subheading}
            containerProps={{ className: classes.subheadingContainer }}
          />
        )}
        {(hasPrimaryCTA || hasSecondaryCTA) && (
          <div className={classes.ctas}>
            {hasPrimaryCTA && (
              <div className="buttonWrapper">
                <Button theme={theme} link={primaryCTA} className="gtm-hero-cta" />
              </div>
            )}
            {hasSecondaryCTA && (
              <div className="buttonWrapper">
                <Button theme={theme} link={secondaryCTA} className="gtm-hero-cta" />
              </div>
            )}
          </div>
        )}
        {children}
      </div>
    </div>
  );
};

export default memo(LandingPageContent);
